import React, { FC, useEffect, useState } from 'react'
import { Box, VStack } from '@chakra-ui/react'
import { ProviderAutoComplete } from './providerAutocomplete'
import { ProviderInfo } from '../../providers'
import { ProviderType } from '../../state/interfaces'
import { useSelector } from 'react-redux'
import { selectScenario } from '../../state'
import { getProviderTypeFromScenario } from '../../scenarios/utils'

export interface InputAutoCompleteProps {
  placeholder?: string
  onChange?: (values: string[]) => void
  name: string
}

export const InputAutoComplete: FC<InputAutoCompleteProps> = ({ placeholder, onChange, name }) => {
  const [providers, setProviders] = useState<ProviderInfo[] | null>([])
  const scenario = useSelector(selectScenario)

  useEffect(() => {
    let endpoint = `${process.env.REACT_APP_MOBILE_PROVIDERS_API_URL}`
    const providerType: ProviderType = getProviderTypeFromScenario(scenario)

    if (providerType === ProviderType.INTERNET) {
      endpoint = `${process.env.REACT_APP_INTERNET_PROVIDERS_API_URL}`
    }

    fetch(endpoint)
      .then((result) => result.json())
      .then((providers) => setProviders(providers))
  }, [])

  return (
    <VStack spacing={3} marginY={8}>
      <Box>
        <ProviderAutoComplete data={providers} placeholder={placeholder} onChange={onChange} name={name} />
      </Box>
    </VStack>
  )
}
